export const modalOverlayStyle = {
  backgroundColor: 'rgba(0,0,0,0.5)'
}; 